import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659c1714"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "provenance",
  "data-test": "provenance"
}

import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid';
import TrackedLink from '@/components/tracking/TrackedLink.vue';
import { useClaimStore } from '@/store/claimStore';

export interface Record {
  label: string;
  link?: string;
  value: string;
}

interface ProvenanceProps {
  records: Record[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Provenance',
  props: {
    records: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "21d945c9": (_unref(store).clientColors.themeSecondary)
}))


const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.records, (record, idx) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (record.link)
          ? (_openBlock(), _createBlock(TrackedLink, {
              key: idx,
              href: record.link,
              label: record.label,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(record.label) + " ", 1),
                  (record.link)
                    ? (_openBlock(), _createBlock(_unref(ArrowTopRightOnSquareIcon), {
                        key: 0,
                        class: "link-icon"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", null, _toDisplayString(record.value), 1)
              ]),
              _: 2
            }, 1032, ["href", "label"]))
          : (_openBlock(), _createElementBlock("div", {
              key: idx * 10
            }, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(record.label) + " ", 1),
                (record.link)
                  ? (_openBlock(), _createBlock(_unref(ArrowTopRightOnSquareIcon), {
                      key: 0,
                      class: "link-icon"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", null, _toDisplayString(record.value), 1)
            ]))
      ], 64))
    }), 256))
  ]))
}
}

})